import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle, FaTimes, FaFileContract, FaGraduationCap, FaArrowRight } from 'react-icons/fa';
import LoginReminders from '../LoginReminders/LoginReminders';
import useAssignmentAlerts from './useAssignmentAlerts';
import styles from './AssignmentAlerts.module.css';

/**
 * İki uyarıyı birlikte yönetir:
 *  1. Son tamamlama tarihine 2 gün kalan atamalar için uygulama geneli
 *     kırmızı uyarı bandı.
 *  2. Girişte bir kez çıkan birleşik hatırlatma penceresi (okunmamış SOP'lar
 *     + eksik CV/GCP/IATA belgeleri) — bkz. LoginReminders.
 */
const AssignmentAlerts = () => {
  const navigate = useNavigate();
  const { dueSoon, unreadSOPs, loaded } = useAssignmentAlerts();
  const [bannerDismissed, setBannerDismissed] = useState(false);

  const goToProfile = () => {
    setBannerDismissed(true);
    // Profil takvimle açılır; bekleyen SOP ve eğitimler Dosyalar sekmesinde
    navigate('/profile', { state: { activeTab: 'dosyalar' } });
  };

  const overdueCount = dueSoon.filter((item) => item.overdue).length;
  const showBanner = loaded && dueSoon.length > 0 && !bannerDismissed;

  return (
    <>
      {showBanner && (
        <div className={styles.banner} role="alert">
          <FaExclamationTriangle className={styles.bannerIcon} />
          <div className={styles.bannerText}>
            <strong className={styles.bannerTitle}>
              {overdueCount > 0
                ? `${overdueCount} atamanızın süresi doldu`
                : `Son 2 gün: tamamlamanız gereken ${dueSoon.length} atama var`}
            </strong>
            <span className={styles.bannerList}>
              {dueSoon.slice(0, 3).map((item) => (
                <span key={`${item.type}-${item.id}`} className={styles.bannerItem}>
                  {item.type === 'SOP' ? <FaFileContract /> : <FaGraduationCap />}
                  {item.name}
                  <span className={styles.bannerDeadline}>{item.deadlineLabel}</span>
                </span>
              ))}
              {dueSoon.length > 3 && (
                <span className={styles.bannerMore}>+{dueSoon.length - 3} tane daha</span>
              )}
            </span>
          </div>
          <button type="button" className={styles.bannerAction} onClick={goToProfile}>
            Tamamla <FaArrowRight />
          </button>
          <button
            type="button"
            className={styles.bannerClose}
            onClick={() => setBannerDismissed(true)}
            aria-label="Uyarıyı kapat"
          >
            <FaTimes />
          </button>
        </div>
      )}

      <LoginReminders unreadSOPs={unreadSOPs} sopsLoaded={loaded} onGoToSops={goToProfile} />
    </>
  );
};

export default AssignmentAlerts;
